import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./assets/css/app.css";

import i18n from "./utils/i18n";

import { useColorSchemeStore } from "@/stores/color-scheme";

const app = createApp(App);

app.use(createPinia());
app.use(router);
import ErrorLogger from '@template/services/ErrorLogger';

app.use(i18n);

ErrorLogger.init(app);

const colorSchemeStore = useColorSchemeStore();
document.documentElement.classList.add(colorSchemeStore.colorScheme);

app.mount("#app");
